export var ChoiceOfLanguages;
(function (ChoiceOfLanguages) {
    ChoiceOfLanguages["Svenska"] = "Svenska";
    ChoiceOfLanguages["English"] = "English";
})(ChoiceOfLanguages || (ChoiceOfLanguages = {}));
